module.exports = __webpack_public_path__ + "static/media/ic_unselected.c1f3fdf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_unselected.svg
// module id = 290
// module chunks = 0